import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { withRouter } from "react-router-dom";
import { MyIcon } from "../../common/baseConfig"
import FeedBackModal from './FeedBackModal'

export class Footer extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.props.actions.fetchGetFooter();
  }
  _selectColor(BackColor) {
    let headbg = '',
      textcolor = ''
    switch (Number(BackColor)) {
      case 1:
        headbg = 'footer_bg_one'
        textcolor = 'text_color_two'
        break;
      case 2:
        headbg = 'footer_bg_two'
        textcolor = 'text_color_one'
        break;
      case 3:
        headbg = 'footer_bg_three'
        textcolor = 'text_color_one'
        break;
      case 4:
        headbg = 'footer_bg_four'
        textcolor = 'text_color_two'
        break;
      default:
        break;
    }
    return { headbg, textcolor }
  }
  render() {
    if (!this.props.common.fetchGetFooterSuccess) return null;
    const { list, BackColor, PoliceNo, RecodeNo, CompanyMail, ContactInfo } = this.props.common.fetchGetFooterSuccess;
    const { isTopicPage } = this.props;
    const headColorData = this._selectColor(BackColor);
    return (
      <div className={`common-footer ${headColorData.headbg} ${headColorData.textcolor}`}>
        <div className="common-footer-inner">
          <p className="p1">
            服务热线（周一至周日 8:00-18:00）
          </p>
          <div className="common-footer-inner-center">
            <div className="left-view">
              <p className="phone">
                {ContactInfo}
              </p>
              <ul>
                {
                  list.map((item, index) => <li key={item.ID}><a className={`common-footer-list-link`} target='_blank' href={item.Url}>{item.MenuName}</a></li>)
                }
              </ul>
            </div>
            <div className="right-view">
              <p>
                <span className="sp1">邮件至</span>
                <span className="sp2">{CompanyMail}</span>
              </p>
              <p>
                <MyIcon className="mail-icon" type="iconyouxiang" />
              </p>
            </div>
          </div>
          <div className="common-footer-inner-bottom">
            <p>{RecodeNo}</p>
            {PoliceNo && PoliceNo.length > 0 ? <img className="" src={require('../../images/base-icon.png')} alt="" /> : ''}
            <p>
              <a href="http://www.beian.miit.gov.cn" target='_blank' rel="noopener noreferrer">登记序号: {PoliceNo}</a>
            </p>
          </div>
        </div>
        {isTopicPage && <FeedBackModal />}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Footer));



// WEBPACK FOOTER //
// ./src/features/common/Footer.js